module.exports = __webpack_public_path__ + "static/alex-hospital-4404f33e31808845b88ae65fc1255309.jpg";